import styled from '@emotion/styled';
import { transparentize } from 'polished';
import theme from '@vromo/ui/components/theme';
import { css } from 'emotion';
import { slideInLeft } from '@vromo/ui/styles/animated';

export const SidebarList = styled.ul`
    width: 100%;
    padding: 0;
    list-style-type: none;
    text-align: left;
    margin: auto;

    li {
        border-right: 3px solid transparent;
        transition: background-color 0.2s ease-in-out;

        a {
            display: inline-block;
            padding: 16px;

            i {
                transition: color 0.2s ease-in-out;
            }
        }

        &:hover {
            background-color: ${transparentize(1 - 0.18, theme.primary)};

            a {
                display: inline-block;
                padding: 16px;
                color: ${theme.primary};

                i {
                    color: ${theme.primary};
                }
            }

            @media (max-width: 1000px) {
                background-color: ${transparentize(1 - 0.18, '#fff')};

                a {
                    color: #fff;

                    i {
                        color: #fff;
                    }
                }
            }
        }
    }
`;

export const getCSSStyles = (open: boolean) => {
    return {
        container: css`
            display: flex;
            flex-direction: column;
            justify-content: stretch;
            height: 100vh;
        `,
        contentContainer: css`
            display: flex;
            flex-direction: row;
            flex: 1;
            background-color: #f3f3f3;
            min-height: 0;
        `,
        leftContent: css`
            display: flex;
            flex-direction: column;
            background-color: white;
            width: 70px;

            @media (max-width: 1000px) {
                width: 170px;
                display: ${open ? 'flex' : 'none'};
                animation: ${slideInLeft} 0.2s ease-in;
                position: fixed;
                top: 0;
                bottom: 0;
                left: 0;
                z-index: 200000;
                background-color: ${theme.primary};
            }
        `,
        mobileTransparency: css`
            display: none;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: rgba(0, 0, 0, 0.3);
            z-index: 100000;

            @media (max-width: 1000px) {
                display: ${open ? 'block' : 'none'};
            }
        `,
        closeButton: css`
            display: none;
            font-size: 36px;
            margin-right: 8px;
            text-align: right;
            cursor: pointer;
            color: white;
            @media (max-width: 1000px) {
                display: block;
            }
        `,
        menuContainer: css`
            align-self: stretch;
            display: flex;
            align-items: center;
            flex: 1;
            min-height: 0;
            overflow-x: hidden;
            overflow-y: auto;
        `,
        childrenContainer: css`
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            overflow-x: hidden;
        `
    };
};

export const linkCSSStyles = {
    container: css`
        display: flex;
        flex-direction: row;
        align-items: center;
    `,
    label: css`
        display: none;
        font-size: 16px;
        margin-left: 8px;
        @media (max-width: 1000px) {
            display: inline-block;
        }
    `
};

export const linkContainerStyle = (match) => css`
    border-right: ${match ? `3px solid ${theme.primary} !important` : 'none'};
    background-color: ${match ? transparentize(1 - 0.18, theme.primary) : 'transparent'};

    a {
        color: ${match ? theme.primary : transparentize(0.5, theme.primary)};
    }

    @media (max-width: 1000px) {
        border-right: ${match ? `3px solid white !important` : 'none'};
        background-color: ${match ? transparentize(1 - 0.18, '#fff') : 'transparent'};

        a {
            color: ${match ? '#fff' : transparentize(0.4, '#fff')};
        }
    }
`;
